"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
// import { PaymentMethod } from '@l2p/pay-api'
var FieldContent_1 = __importDefault(require("./FieldContent"));
var PaymentsFields = function (_a) {
    var selectedMethod = _a.selectedMethod, type = _a.type, currency = _a.currency, isModal = _a.isModal, accountTypes = _a.accountTypes, paymentSettings = _a.paymentSettings;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isModal ? styles_module_scss_1.default.isModal : '') },
        react_1.default.createElement(FieldContent_1.default, { currentCurrency: currency, type: type, selectedMethod: selectedMethod, accountTypes: accountTypes, paymentSettings: paymentSettings })));
};
exports.default = PaymentsFields;
